//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: "InspectionTemplateItemModal",
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: "巡检内容表单",
      tableName: "om_inspection_template_item",
      form_fields: ['pointId', 'name', 'category', 'defaultValue', 'status', 'delFlag', 'sort'],
      form_fields_time: [],
      validatorRules: {
        pointId: {
          rules: [{
            required: true,
            message: '请输入模板点位id!'
          }]
        },
        name: {
          rules: [{
            required: true,
            message: '请输入检查内容名称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入输入类型：1=是否（开关）;2=有无（开关）;8=数字输入;9=文本输入;!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        delFlag: {
          rules: [{
            required: true,
            message: '请输入删除状态!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {},
  methods: {}
};